module.exports = __webpack_public_path__ + "components/wind-icon/static/SSE@2x-39ea1a11e3ac5f2e5c0d46e5f29b89d1.png";